<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import PosUiInput from '@/components/pos-v2/ui/PosUiInput.vue';
  import { useCatalogPage } from '@/composition/catalog/catalog-page-context';

  /**
   * «Buscar producto» (plan §5.7): the list follows the text debounced, and
   * clearing it also drops the rows kept by earlier actions.
   */
  const props = withDefaults(defineProps<{ autofocus?: boolean }>(), {
    autofocus: false,
  });

  const { state, url } = useCatalogPage();
  const root = ref<HTMLElement | null>(null);

  function onInput(text: string) {
    if (text) state.query = text;
    else url.clearSearch();
  }

  function focus() {
    root.value
      ?.querySelector<HTMLInputElement>('input')
      ?.focus({ preventScroll: true });
  }

  onMounted(() => {
    if (props.autofocus) focus();
  });

  defineExpose({ focus });
</script>

<template>
  <div ref="root" class="v2-catalog-search-field">
    <PosUiInput
      :value="state.query"
      icon="magnify"
      clearable
      type="search"
      autocomplete="off"
      :maxlength="100"
      :placeholder="$t('menuPage.search.placeholder')"
      :aria-label="$t('menuPage.search.placeholder')"
      @input="onInput"
    />
  </div>
</template>

<style scoped lang="scss">
  .v2-catalog-search-field {
    @apply tw-min-w-0;

    // The browser's own clear button duplicates PosUiInput's.
    ::v-deep input[type='search']::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
  }
</style>
